const ADD_SHIFT_SUCCESS_TEXT = "L'horaire a été ajouté.";
const DELETE_SHIFT_SUCCESS_TEXT = "L'horaire a été supprimé.";
const UPDATE_SHIFT_SUCCESS_TEXT = "L'horaire a été modifié.";

export const ADD_SHIFT_SUCCESS = ADD_SHIFT_SUCCESS_TEXT;
export const DELETE_SHIFT_SUCCESS = DELETE_SHIFT_SUCCESS_TEXT;
export const UPDATE_SHIFT_SUCCESS = UPDATE_SHIFT_SUCCESS_TEXT;

const ADD_CLOSED_DAY_SUCCESS_TEXT = "La fermeture a été ajoutée.";
const DELETE_CLOSED_DAY_SUCCESS_TEXT = "La fermeture a été supprimée.";
const UPDATE_CLOSED_DAY_SUCCESS_TEXT = "Le fermeture a été modifiée.";

export const ADD_CLOSED_DAY_SUCCESS = ADD_CLOSED_DAY_SUCCESS_TEXT;
export const DELETE_CLOSED_DAY_SUCCESS = DELETE_CLOSED_DAY_SUCCESS_TEXT;
export const UPDATE_CLOSED_DAY_SUCCESS = UPDATE_CLOSED_DAY_SUCCESS_TEXT;


// WEBPACK FOOTER //
// ./src/successes/shifts.js